import { P, Predicate } from "breadcommon";

export interface TransactionColumnFilterDisplayDescriptionProps {
  predicate: Predicate;
}

export function TransactionColumnFilterDisplayDescription({
  predicate,
}: TransactionColumnFilterDisplayDescriptionProps): JSX.Element {
  // Parse the predicate to extract the search text and match type
  // Expected structure: P.SubstringCI(P.Field("description"), P.Literal(string)) or P.EqualsCI(...)
  const serializable = predicate.asSerializable();

  if (
    (serializable.name === P.OpName.SubstringCI ||
      serializable.name === P.OpName.EqualsCI) &&
    serializable.args.length === 2
  ) {
    const literalOp = serializable.args[1];
    if (literalOp.name === P.OpName.Literal) {
      const searchText = literalOp.args[0];
      if (typeof searchText === "string") {
        const isExact = serializable.name === P.OpName.EqualsCI;
        return (
          <span>
            Description {isExact ? "is" : "contains"} "{searchText}"
          </span>
        );
      }
    }
  }

  // Fallback if predicate structure is unexpected
  return <span>Description filter</span>;
}
